import React from 'react';

interface TitleBarProps {
  title: string;
}

export const TitleBar: React.FC<TitleBarProps> = ({ title }) => {
  return (
    <div className="title-bar">
      <h1>{title}</h1>
    </div>
  );
};
